import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';
import 'moment-timezone';

@Injectable()
export class TimeZoneService {
  constructor() {}

  getTimeZone(lat: string, lng: string): string {
    return tzlookup(lat, lng);
  }

  getTimeZoneOffset(timeZone: string): number | null {
    const now = new Date();
    // utcOffset espera un número (timestamp en milisegundos), no un objeto Date
    const gmtOffset = moment.tz.zone(timeZone)?.utcOffset(now.getTime());
    
    if (gmtOffset != null) {
      return -gmtOffset;
    } else {
      return null;
    }
  }

  getGmtDate(lat: string, lng: string) {
    const timeZoneInfo = tzlookup(lat, lng);
    if (timeZoneInfo) {
      const today = moment.tz(timeZoneInfo);
      return today.toDate(); 
    } else {
      return null;
    }
  }

  convertToGMTZero(date: Date, timeZoneOffset: number, dateText?: boolean) {
    const gmtTimeOffset = -timeZoneOffset
    const gmtOffsetMilliseconds = gmtTimeOffset * 60000;
    const dateInGMT = new Date(date.getTime() + gmtOffsetMilliseconds);
    
    dateInGMT.setMinutes(dateInGMT.getMinutes() - dateInGMT.getTimezoneOffset());

    const dateInGMTZero = dateInGMT.toISOString();
    
    return dateText ? dateInGMTZero : new Date(dateInGMTZero);
  }

  convertToGMTDate(date: Date, timezoneOffset: number) {
    const gmtOffsetMilliseconds = timezoneOffset * 60000;
    const dateInGMT = new Date(date.getTime() + gmtOffsetMilliseconds);
    
    

    return dateInGMT;
  }

  getBrowserTimeZoneName() {
    const timeZone = Intl.DateTimeFormat(undefined, { timeZoneName: 'short' })
      .resolvedOptions()
      .timeZone;
    return timeZone;
  }
  
  getZoneZFormat(timeZoneName: string){
     return moment.tz(moment(), timeZoneName).format('z');
  }
}